import Page from "webPage/Page";
import { handleTestimonialSlider } from "util/Testimonials";

Page.register('post-type-archive-faq', () => {
    $('body').on('click', '.js-faq-item', function(){
        $(this).parent('.faq-item').toggleClass('faq-item--active');
        $(this).closest('.faq-item').find('.faq-item__content').stop().slideToggle(300);
    });
});
